export default __webpack_public_path__ + "static/media/us_bg.80d8109e.png";